import React, { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { BsTwitter, BsInstagram } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
import { FiLinkedin } from "react-icons/fi";

import ArrowLeft from "../components/ArrowLeft";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [currentStep, setCurrentStep] = useState(1);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isEmptyFields, setIsEmptyFields] = useState(false);
  const [loading, setLoading] = useState(false);
  const [nameError, setNameError] = useState(null);
  const [emailError, setEmailError] = useState(null);
  const [messageError, setMessageError] = useState(null);
  const URL = process.env.REACT_APP_API_URL;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const submitFormData = async (formData) => {
    setCurrentStep(1);
    if (
      formData.name.trim() === "" ||
      formData.email.trim() === "" ||
      formData.message.trim() === ""
    ) {
      return;
    }

    axios.post(`${URL}/contact/`, formData).then(() => {
      setLoading(false);
      setFormSubmitted(true);
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("form data:", formData);

    if (formData.name.trim() === "") {
      setNameError("Name is required");
    } else {
      setNameError("");
    }

    if (formData.email.trim() === "") {
      setEmailError("email is required");
    } else {
      setEmailError("");
    }

    if (formData.message.trim() === "") {
      setMessageError("Message is required");
    } else {
      setMessageError("");
      submitFormData(formData);
      setFormSubmitted(true);
    }
  };

  return (
    <motion.div
      initial={{
        width: "0%",
      }}
      animate={{
        width: "100%",
      }}
      exit={{
        width: "0%",
      }}
      transition={{
        duration: 0.2,
      }}
      className="w-full flex flex-col mt-20 justify-start items-center min-h-[100vh] relative bg shadow-xl"
    >
      <ArrowLeft link="/skill" />
      <div className="md:w-[60%] w-[100%] px-6 md:px-0 h-full flex flex-col justify-start items-start">
        <div className="w-full flex flex-col justify-start">
          <p className="text-[25px] md:text-[32px] font-bold text-yellow-400 my-3">
            Get in touch
          </p>

          <p className="md:text-[20px] text-[17px] text-gray-300">
            If you wanna get in touch, talk to me about a project collaboration
            or just say hi, fill up the awesome form below or send an email to
            mysviurch@gmail.com and ~let's talk.
          </p>
        </div>

        <div className="w-full mt-6 flex flex-col justify-start">
          {!formSubmitted ? (
            <form className="w-full flex flex-col justify-start">
              <div className="mt-6">
                <input
                  className="w-[100%] py-2 outline-none border-b border-gray-500 bg text-[20px]"
                  placeholder="Fill Your Name"
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
                <p className="error">{nameError}</p>
              </div>

              <div className="mt-6">
                <input
                  className="w-[100%] py-2 outline-none border-b border-gray-500 bg text-[20px]"
                  placeholder="Fill Your Email"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
                <p className="error">{emailError}</p>
              </div>

              <div className="mt-6">
                <textarea
                  className="w-[100%] p-0 outline-none border-b border-gray-500 bg text-[20px]"
                  placeholder="Your Message"
                  value={formData.message}
                  name="message"
                  onChange={handleChange}
                />
                <p className="error">{messageError}</p>
              </div>

              <div className="flex mt-3">
                <button
                  className="bg-gray-400 opacity-80 w-auto p-3 rounded-md shadow-lg hover:opacity-100"
                  onClick={handleSubmit}
                  type="submit"
                >
                  {nameError || emailError || messageError
                    ? "Submit Your Message"
                    : loading
                    ? "Sending"
                    : "Submit Your Message"}
                </button>
              </div>
            </form>
          ) : (
            <div>
              <h3 className="head-text">Thank You for getting in touch!</h3>
            </div>
          )}
        </div>

        <div className="w-full mt-20 flex flex-col justify-start">
          <p className="md:text-[24px] text-[18px] font-bold mt-2">
            Let's get social
          </p>
          <p className="text-[17px]">
            Follow me Twitter(X), GitHub and Linkedin.
          </p>

          <div className=" w-[100%] flex my-6">
            <a href="https://twitter.com/UrchDev">
              <div className="bg-black w-auto p-3 flex justify-center items-center hover:w-[100px]">
                <BsTwitter className="md:w-[30px] md:h-[30px] w-[15px] h-[15px] " />{" "}
                <p className="ml-2">Twitter</p>
              </div>
            </a>
            <a href="https://github.com/Kelviz">
              <div className="bg-gray-500 w-auto p-3 ml-3 flex justify-center items-center hover:w-[100px]">
                <FaGithub className="md:w-[30px] md:h-[30px] w-[15px] h-[15px]  " />{" "}
                <p className="ml-2">GitHub</p>
              </div>
            </a>
            <a href="https://www.linkedin.com/in/urch-ezedinma-3b4451295/">
              <div className=" bg-blue-600 w-auto p-3 ml-3 flex justify-center items-center  hover:w-[100px]">
                <FiLinkedin className="md:w-[30px] md:h-[30px] w-[15px] h-[15px] " />{" "}
                <p className="ml-2">Linkedin</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Contact;
